import { Images } from '@business/assets/images';
import { getOpacityRequired } from '@ports/common/manualLoadingStateSlice';
import { RootState } from '@reduxjs/toolkit/query';
import { apiSlices } from '@utils/helpers/lib/getState';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const AppLoader = () => {
  const isOpacityRequired = useSelector(getOpacityRequired);
  const isPending = useSelector((state: RootState<any, any, any>) => state);
  const dispatch = useDispatch();
  const [isPendingData, setIsPendingData] = useState<boolean>(false);
  const ignoreList = [
    // 'userUsersList',
    // 'regionZipcodesList',
    // 'regionZipcodesUploadFile',
    // 'regionStateUploadFile'
  ] as any;
  useEffect(() => {
    const pendingData = Object.values(isPending)
      ?.filter((item: any) => item?.queries || item?.mutations)
      ?.flatMap((item: any) => [
        ...Object.values(item.queries || {}),
        ...Object.values(item.mutations || {})
      ])
      ?.filter((item: any) => !ignoreList.includes(item?.endpointName))
      ?.some((query: any) => query.status === 'pending');
    setIsPendingData(pendingData ? pendingData : false);
  }, [isPending]);

  useEffect(() => {
    const rejectPendingRequests = () => {
      const pendingEndpoints = Object.values(isPending)
        ?.filter((item: any) => item?.queries || item?.mutations)
        ?.flatMap((item: any) => [
          ...Object.values(item.queries || {}),
          ...Object.values(item.mutations || {})
        ])
        ?.filter((item: any) => !ignoreList.includes(item?.endpointName))
        ?.filter((query: any) => query.status === 'pending');
      if (pendingEndpoints?.length > 0) {
        const pendingApis = pendingEndpoints?.map(
          (item: any) => item.endpointName
        );

        apiSlices.forEach((api: any) => {
          const apiEndpoints = Object.keys(api?.endpoints ?? {});
          const hasPending = apiEndpoints?.some(endpoint =>
            pendingApis?.includes(endpoint)
          );
          if (hasPending) {
            dispatch(api?.util?.resetApiState());
          }
        });
      }
    };
    rejectPendingRequests();
  }, []);

  return (
    <>
      {isPendingData && (
        <div
          data-testid="loader"
          className={`z-[99999] fixed top-0 left-0 w-screen h-screen flex align-center justify-center select-none overflow-none ${isOpacityRequired ? 'bg-white' : 'bg-white/75'} `}>
          <img
            src={Images.Loader}
            height={200}
            width={200}
            alt="loadingIcon"
            className="object-contain"
          />
        </div>
      )}
    </>
  );
};
